// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ADD_EMPLOYEE_SALARY, EMPLOYEE_SALARY, EDIT_EMPLOYEE_SALARY, GET_EMPLOYEE_SALARY, DELETE_EMPLOYEE_SALARY, GENERATE_EMPLOYEE_SALARY } from '../../../../common/constant'

export const actionEmployeeSalary = createAsyncThunk('appEmployeeSalary/actionEmployeeSalary', async (params, thunkAPI) => {
    return await post(EMPLOYEE_SALARY, params, thunkAPI)
})

export const actionAddEmployeeSalary = createAsyncThunk('appEmployeeSalary/actionAddEmployeeSalary', async (params, thunkAPI) => {
    return await put(ADD_EMPLOYEE_SALARY, params, thunkAPI)
})

export const actionGetEmployeeSalary = createAsyncThunk('appEmployeeSalary/actionGetEmployeeSalary', async (params, thunkAPI) => {
    return await post(GET_EMPLOYEE_SALARY, params, thunkAPI)
})

export const actionEditEmployeeSalary = createAsyncThunk('appEmployeeSalary/actionEditEmployeeSalary', async (params, thunkAPI) => {
    return await post(EDIT_EMPLOYEE_SALARY, params, thunkAPI)
})

export const actionDeleteEmployeeSalary = createAsyncThunk('appEmployeeSalary/actionDeleteEmployeeSalary', async (params, thunkAPI) => {
    return await post(DELETE_EMPLOYEE_SALARY, params, thunkAPI)
})

export const actionGenerateEmployeeSalary = createAsyncThunk('appEmployeeSalary/actionGenerateEmployeeSalary', async (params, thunkAPI) => {
    return await post(GENERATE_EMPLOYEE_SALARY, params, thunkAPI)
})

export const appEmployeeSalarySlice = createSlice({
    name: 'appEmployeeSalary',
    initialState: {
        //list
        loading: false,
        employeeSalary: null,

        //add
        loadingAdd: false,
        addEmployeeSalary: null,

        //get
        loadingGet: false,
        getEmployeeSalary: null,

        //edit
        loadingEdit: false,
        editEmployeeSalary: null,

        //delete
        loadingDelete: false,
        deleteEmployeeSalary: null,

        //generate
        loadingGenerate: false,
        generateEmployeeSalary: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetEmployeeSalaryResponse: (state) => {
            state.employeeSalary = null
        },
        resetAddEmployeeSalaryResponse: (state) => {
            state.addEmployeeSalary = null
        },
        resetGetEmployeeSalaryResponse: (state) => {
            state.getEmployeeSalary = null
        },
        resetEditEmployeeSalaryResponse: (state) => {
            state.editEmployeeSalary = null
        },
        resetDeleteEmployeeSalaryResponse: (state) => {
            state.deleteEmployeeSalary = null
        },
        resetGenerateEmployeeSalaryResponse: (state) => {
            state.generateEmployeeSalary = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionEmployeeSalary.pending, (state) => {
                state.loading = true
            })
            .addCase(actionEmployeeSalary.fulfilled, (state, action) => {
                state.loading = false
                state.employeeSalary = action.payload
            })
            .addCase(actionEmployeeSalary.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddEmployeeSalary.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddEmployeeSalary.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addEmployeeSalary = action.payload
            })
            .addCase(actionAddEmployeeSalary.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetEmployeeSalary.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetEmployeeSalary.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getEmployeeSalary = action.payload
            })
            .addCase(actionGetEmployeeSalary.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditEmployeeSalary.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditEmployeeSalary.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editEmployeeSalary = action.payload
            })
            .addCase(actionEditEmployeeSalary.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteEmployeeSalary.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteEmployeeSalary.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteEmployeeSalary = action.payload
            })
            .addCase(actionDeleteEmployeeSalary.rejected, (state) => {
                state.loadingDelete = false
            })

            //generate
            .addCase(actionGenerateEmployeeSalary.pending, (state) => {
                state.loadingGenerate = true
            })
            .addCase(actionGenerateEmployeeSalary.fulfilled, (state, action) => {
                state.loadingGenerate = false
                state.generateEmployeeSalary = action.payload
            })
            .addCase(actionGenerateEmployeeSalary.rejected, (state) => {
                state.loadingGenerate = false
            })
    }
})
export const { resetEmployeeSalaryResponse, resetAddEmployeeSalaryResponse, resetGetEmployeeSalaryResponse, resetEditEmployeeSalaryResponse, resetDeleteEmployeeSalaryResponse, resetGenerateEmployeeSalaryResponse } = appEmployeeSalarySlice.actions

export default appEmployeeSalarySlice.reducer